import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultValue", "enlargeOnSelect", "height", "id", "isFlat", "isShowingDescriptionOnSelect", "layout", "left", "name", "onChange", "onDisabledClick", "onLayout", "options", "renderOption", "shouldWordsBreak", "singleRow", "size", "testID", "UNSAFE_containerProps", "value"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { omit } from 'ramda';
import useUncontrolledProp from '@bubble-ui/hook-use-uncontrolled-prop';
import { useUniqueFormIdentifier } from '@bubble-ui/hook-use-unique-form-identifier';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var BoxSelectorBaseComponent = _ref => {
  var {
      defaultValue,
      enlargeOnSelect,
      height,
      id,
      isFlat,
      isShowingDescriptionOnSelect,
      layout,
      left,
      name,
      onChange,
      onDisabledClick,
      onLayout,
      options,
      renderOption,
      shouldWordsBreak,
      singleRow,
      size,
      testID,
      UNSAFE_containerProps,
      value
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'BoxSelectorDetailed',
    propName: 'isFlat',
    shouldWarn: isFlat !== undefined,
    removalDate: 'v6.0.0'
  });
  var isVertical = layout === 'vertical';
  var componentName = useUniqueFormIdentifier({
    name,
    fallbackName: 'BoxSelectorBase'
  });

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    containerStyle
  } = useStyleSheet(BoxSelectorBaseComponent, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
    defaultValue,
    enlargeOnSelect,
    height,
    id,
    isFlat,
    isShowingDescriptionOnSelect,
    isVertical,
    layout,
    left,
    name,
    onChange,
    onDisabledClick,
    onLayout,
    options,
    renderOption,
    shouldWordsBreak,
    singleRow,
    size,
    testID,
    UNSAFE_containerProps,
    value
  }));
  var [boxSelectorValue, setBoxSelectorValue] = useUncontrolledProp({
    prop: value,
    defaultProp: defaultValue,
    onChange
  });
  return (
    /*#__PURE__*/
    // FIXME: don't spread same props twice!
    React.createElement("div", _extends({}, UNSAFE_containerProps, {
      id: id,
      style: containerStyle
    }, omit(['onDisabledClick', 'isFlat', 'size', 'singleRow', 'shouldWordsBreak'], props)), options.map((option, index) => renderOption(_objectSpread(_objectSpread(_objectSpread({
      enlargeOnSelect,
      isChecked: option.value === boxSelectorValue,
      isPreviousBoxChecked: options[index - 1] && options[index - 1].value === boxSelectorValue,
      isNextBoxChecked: options[index + 1] && options[index + 1].value === boxSelectorValue,
      isFirst: index === 0,
      isLast: options.length - 1 === index,
      isShowingDescriptionOnSelect,
      isVertical,
      left,
      name: componentName,
      onChange: setBoxSelectorValue,
      onDisabledClick,
      shouldWordsBreak,
      singleRow,
      size
    }, props), option), {}, {
      key: "".concat(option.value, "-").concat(index)
    }))))
  );
};
BoxSelectorBaseComponent.displayName = 'BoxSelectorBase';
export var BoxSelectorBase = withProvisionalOverrideFromContext(BoxSelectorBaseComponent);
//# sourceMappingURL=BoxSelectorBase.js.map